import React, { ReactElement } from 'react';

import { IconFillColor, IconWrapper, StyledMargin } from '@dreryk/react-components';

type VisitEncounterModeIconProps = {
   icon: ReactElement;
};

export const VisitEncounterModeIcon = (props: VisitEncounterModeIconProps): JSX.Element => {
   return (
      <StyledMargin right={4}>
         <IconWrapper testId={'visitEncounterModeIcon'} fillColor={IconFillColor.BACKGROUND}>
            {props.icon}
         </IconWrapper>
      </StyledMargin>
   );
};
